import { createClient } from "@supabase/supabase-js";
import { UserService } from "./user.service";
const SUPABASE_URL = "https://vhlvapimmiautphegmxa.supabase.co";
const SUPABASE_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJyb2xlIjoiYW5vbiIsImlhdCI6MTYyMDEyMDU5MSwiZXhwIjoxOTM1Njk2NTkxfQ.FAVjq1PoOfWGIsqAd_DxvspcPA0e7f9ZswLHUum2jvA";
export class BoardService {
    constructor() {
        this.supabase = createClient(SUPABASE_URL, SUPABASE_KEY);
        this.userService = UserService.getInstance();
    }
    static getInstance() {
        if (!BoardService.instance) {
            BoardService.instance = new BoardService();
        }
        return BoardService.instance;
    }
    async saveBoard(entries) {
        var _a;
        const userId = (_a = this.userService.currentUser()) === null || _a === void 0 ? void 0 : _a.id;
        if (!userId)
            return;
        const { data, error } = await this.supabase
            .from("board")
            .upsert([{ id: userId, entries }])
            .eq("id", userId);
        if (error)
            throw error;
    }
    async findBoard() {
        var _a;
        const userId = (_a = this.userService.currentUser()) === null || _a === void 0 ? void 0 : _a.id;
        if (!userId)
            return null;
        const { data, error } = await this.supabase
            .from("board")
            .select("entries")
            .eq("id", userId);
        if (error)
            throw error;
        return data.length > 0 ? data[0].entries : [];
    }
}
